import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FicScreenService } from './fic-screen.service';
import { FicScreenPortalComponent } from './fic-screen-portal.component';
import { FicScreenComponent } from './fic-screen.component';
import { FicScreenHeaderComponent } from './header/fic-screen-header.component';
import { FicScreenContentComponent } from './content/fic-screen-content.component';
import { FicScreenBtnCloseComponent } from './btn-close/fic-screen-btn-close.component';
import { FicScreenHeaderTranscludeComponent } from './header/fic-screen-header-transclude.component';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatIconModule],
    declarations: [
        FicScreenPortalComponent,
        FicScreenComponent,
        FicScreenHeaderComponent,
        FicScreenHeaderTranscludeComponent,
        FicScreenContentComponent,
        FicScreenBtnCloseComponent,
    ],
    exports: [
        FicScreenComponent,
        FicScreenHeaderComponent,
        FicScreenHeaderTranscludeComponent,
        FicScreenContentComponent,
        FicScreenBtnCloseComponent,
    ],
    providers: [FicScreenService],
})
export class FicScreenModule {}
